<!-- Adapted from SPlayer 40d9ec6 src/components/List/CoverList.vue (AGPL-3.0).
     Original cover-grid/cover-item/cover-data composition; shared Cover supplies actions. -->
<template>
  <div class="cover-list" :class="type">
    <div class="cover-grid">
      <article v-for="item in items" :key="item.id" class="cover-item">
        <div class="cover">
          <Cover :id="item.id" :label="item.name" :type="type" :image-url="coverUrl(item)" :cover-hover="false" :radius="6" />
          <span v-if="type === 'playlist' && item.playCount" class="play-count">{{ formatCount(item.playCount) }}</span>
        </div>
        <div class="cover-data">
          <router-link class="name" :to="{ name: type, params: { id: String(item.id) } }">{{ item.name }}</router-link>
          <span v-if="subtitle(item)" class="tip">{{ subtitle(item) }}</span>
        </div>
      </article>
    </div>
  </div>
</template>
<script>
import Cover from '../../components/Cover.vue';
import { runtime } from '../../bridge';
export default {
  name: 'SPlayerCoverList', components: { Cover },
  props: { items: { type: Array, required: true }, type: { type: String, default: 'playlist' } },
  methods: {
    coverUrl(item) { return item.coverImgUrl || item.picUrl || runtime.cover(); },
    formatCount(value) { return value >= 100000000 ? (value / 100000000).toFixed(1) + '亿' : value >= 10000 ? Math.floor(value / 10000) + '万' : String(value); },
    subtitle(item) { return this.type === 'album' ? (item.artists || (item.artist ? [item.artist] : [])).map(artist => typeof artist === 'string' ? artist : artist.name).join(' / ') : item.updateFrequency || item.copywriter || item.creator?.nickname || ''; },
  },
};
</script>
<style lang="scss" scoped>
.cover-list { width: 100%; padding: 12px 0 0; }
.cover-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(155px, 1fr)); gap: 18px; }
.cover-item { min-width: 0; height: auto; border-radius: 6px; transition: background-color .2s; }
.cover-item:hover { background: var(--salt-hover, #8881); }
.cover { position: relative; aspect-ratio: 1; }
.cover ::v-deep img { border-radius: 6px; }
.cover ::v-deep .play-button { position:relative; flex:0 0 32px; width:32px !important; height:32px !important; min-width:32px; min-height:32px; padding:0; border:0; border-radius:9999px; background:var(--salt-accent,#0470e6); color:var(--salt-on-accent,#fff); backdrop-filter:none; box-shadow:none; transform:none; transition:none; overflow:hidden; isolation:isolate; }
.cover ::v-deep .play-button:hover,.cover ::v-deep .play-button:active { background:var(--salt-accent,#0470e6); transform:none; }
.cover ::v-deep .play-button .svg-icon { width:16px; height:16px; margin:0; }
.cover ::v-deep .play-button::after { content:''; position:absolute; inset:0; pointer-events:none; }
.cover ::v-deep .play-button:not(:disabled):hover::after,.cover ::v-deep .play-button:not(:disabled):focus-visible::after { background:var(--salt-hover-overlay,rgb(0 0 0 / 10%)); }
.cover ::v-deep .play-button:not(:disabled):active::after { background:var(--salt-press-overlay,rgb(0 0 0 / 30%)); }
.cover ::v-deep .play-button:disabled { opacity:1; color:var(--salt-disabled-content); background:var(--salt-sub-background); }
.play-count { position: absolute; top: 8px; right: 8px; padding: 2px 6px; border-radius: 4px; background: #0007; color: white; font-size: 11px; pointer-events: none; }
.cover-data { display:flex; flex-direction:column; gap:2px; padding:8px 0; }
.name { display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; color: inherit; text-decoration: none; font-size: 14px; line-height: 1.4; }
.tip { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--salt-subtext, var(--color-secondary)); font-size: 12px; }
@container (max-width: 440px) { .cover-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; } }
</style>
